module.exports = __webpack_public_path__ + "static/media/05.96874bc8.mp3";